import Flex from '@decisiv/ui-components/lib/components/Flex';
import { P } from '@decisiv/ui-components/lib/components/Typography';
import { TypographyColorKeys } from '@decisiv/ui-components/lib/components/Typography/withColors';
import styled from 'styled-components';

type Props = {
  textAlign?: 'left' | 'start' | 'center' | 'end' | 'right';
  topLine?: React.ReactNode;
  color?: TypographyColorKeys;
  bottomLine?: string | React.ReactNode;
};

const FullWidthFlex = styled(Flex).attrs({ flexDirection: 'column' })`
  width: 100%;
  white-space: nowrap;
  text-align: ${(props: Props) => props.textAlign || 'start'};
` as typeof Flex;

export default function PlainTextCell({
  bottomLine = '',
  topLine,
  color,
  ...props
}: Props) {
  const text = topLine || '–';
  return (
    <FullWidthFlex {...props}>
      <P color={color} as="span">
        {text}
      </P>
      <P color={color} as="span" size="small" shade={1}>
        {bottomLine}
      </P>
    </FullWidthFlex>
  );
}
